import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toastErrorr } from "../../../Helper/ToastMessage";
import { BaseUrl } from "../../../Helper/BaseUrl";

export const DailyWorkChecklistProgressWiseEmployeeAPI = createAsyncThunk("EmployeeWiseProgress", async ({ data }) => {
    const {
        M_FinancialYearID,
        M_MonthID,
        M_ZoneID,
        M_WardID,
        M_AssetTypeID,
        M_WorkTypeID,
        M_WeekID,
        M_OfficerID,
        token,
        M_UserID,
        Flag,
        Language,
        handleGetCount,
        DashProjectTypeId,
        RoleID
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let url

    url = `${BaseUrl}/APKDashboard/Get_WEB_GD_T_KPIUploadDailyWork_ChecklistProgress_Wise_Employee_Select?M_FinancialYearID=${M_FinancialYearID}&M_MonthID=${M_MonthID}&M_ZoneID=${M_ZoneID}&M_WardID=${M_WardID}&M_AssetTypeID=${M_AssetTypeID}&M_WorkTypeID=${M_WorkTypeID}&M_WeekID=${M_WeekID}&M_OfficerID=${M_OfficerID}&M_UserID=${M_UserID}&Language=English&Flag=${Flag}&From=1&To=99999`

    return fetch(url, requestOptions)

        .then((res) => res.json())

        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {

                return result.data.table
            } else {
                return
            }
        })
        .catch((err) => {
            console.log("Error:", err)
            return err
        })

})

const DailyWorkChecklistProgressWiseEmployeeSlice = createSlice({
    name: "EmployeeWiseProgress",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(DailyWorkChecklistProgressWiseEmployeeAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(DailyWorkChecklistProgressWiseEmployeeAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(DailyWorkChecklistProgressWiseEmployeeAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const DailyWorkChecklistProgressWiseEmployeeSliceReducer = DailyWorkChecklistProgressWiseEmployeeSlice.reducer